export default __webpack_public_path__ + "static/media/ic-direct-ownership.824a5d88.svg";